import { Mail, Facebook, Instagram, Copy, Check } from "lucide-react";
import { useState } from "react";

const EMAIL = "ReversingStigma@gmail.com";

export default function Connect() {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {}
  };

  return (
    <div data-testid="connect-page">
      <section className="bg-[var(--rts-blue-pale)] py-20">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <span className="inline-block text-xs font-bold tracking-[0.25em] uppercase text-[var(--rts-red)] mb-4">
            Get In Touch
          </span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[var(--rts-ink)] leading-[1.05]">
            Connect with Us
          </h1>
          <p className="mt-5 text-base md:text-lg text-[var(--rts-ink-soft)] max-w-2xl mx-auto leading-relaxed">
            Questions, partnerships, stories to share - we'd love to hear from you. Send us an email and a real human will respond.
          </p>
        </div>
      </section>

      <section className="bg-white py-24">
        <div className="max-w-3xl mx-auto px-6">
          <div className="rounded-3xl border-2 border-[var(--rts-blue-pale)] bg-white p-8 sm:p-12 text-center shadow-sm">
            <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-[var(--rts-blue-deep)] grid place-items-center" data-testid="email-icon">
              <Mail className="w-8 h-8 text-white" />
            </div>
            <p className="text-xs uppercase tracking-[0.3em] text-[var(--rts-muted)] font-bold mb-3">Email us at</p>
            <a
              href={`mailto:${EMAIL}`}
              className="font-display text-xl sm:text-2xl md:text-3xl lg:text-4xl text-[var(--rts-blue-deep)] hover:text-[var(--rts-red)] transition-colors inline-block"
              data-testid="connect-email-link"
            >
              <span className="whitespace-nowrap">ReversingStigma</span><wbr /><span className="whitespace-nowrap">@gmail.com</span>
            </a>
            <div className="mt-7 flex flex-wrap justify-center gap-3">
              <a
                href={`mailto:${EMAIL}`}
                className="inline-flex items-center gap-2 bg-[var(--rts-red)] hover:bg-[var(--rts-red-deep)] text-white px-6 py-3 rounded-full font-bold shadow-lg transition hover:-translate-y-0.5"
                data-testid="connect-mailto-button"
              >
                <Mail className="w-4 h-4" /> Open Email App
              </a>
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${EMAIL}`}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-white border-2 border-[var(--rts-blue)]/30 hover:border-[var(--rts-blue)] text-[var(--rts-blue-deep)] px-6 py-3 rounded-full font-bold transition"
                data-testid="connect-gmail-button"
              >
                <i className="fa-brands fa-google" /> Compose in Gmail
              </a>
              <button
                onClick={copyEmail}
                className="inline-flex items-center gap-2 bg-white border-2 border-[var(--rts-blue)]/30 hover:border-[var(--rts-blue)] text-[var(--rts-blue-deep)] px-6 py-3 rounded-full font-bold transition"
                data-testid="connect-copy-button"
                aria-label="Copy email address"
              >
                {copied ? <><Check className="w-4 h-4" /> Copied</> : <><Copy className="w-4 h-4" /> Copy Address</>}
              </button>
            </div>
            <p className="mt-5 text-xs text-[var(--rts-muted)] max-w-md mx-auto leading-relaxed">
              "Open Email App" uses your device's default mail app. If nothing happens, use "Compose in Gmail" or copy the address and paste it into your favorite email tool.
            </p>
          </div>

          {/* Social */}
          <div className="mt-10 text-center">
            <p className="text-xs uppercase tracking-[0.3em] text-[var(--rts-muted)] font-bold mb-4">Or follow us</p>
            <div className="flex justify-center gap-3">
              <a
                href="https://www.facebook.com/PARSProjectAddictionReversingtheStigma/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-12 h-12 grid place-items-center rounded-full bg-[var(--rts-blue-pale)] hover:bg-[var(--rts-blue)] hover:text-white text-[var(--rts-blue-deep)] transition"
                data-testid="connect-facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://www.instagram.com/p._a._r._s/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-12 h-12 grid place-items-center rounded-full bg-[var(--rts-blue-pale)] hover:bg-[var(--rts-blue)] hover:text-white text-[var(--rts-blue-deep)] transition"
                data-testid="connect-instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
            </div>
            <p className="mt-5 font-display text-xl text-[var(--rts-blue-deep)]">#ReversingTheStigma</p>
          </div>
        </div>
      </section>
    </div>
  );
}
